import { render } from "./FeaturesComponent.vue?vue&type=template&id=f04777c4&scoped=true"
import script from "./FeaturesComponent.vue?vue&type=script&lang=js"
export * from "./FeaturesComponent.vue?vue&type=script&lang=js"

import "./FeaturesComponent.vue?vue&type=style&index=0&id=f04777c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f04777c4"]])

export default __exports__